module.exports = __webpack_public_path__ + "static/media/illustration.f5b6b20d.png";